/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ error: NonNullable<unknown> }} Error_MessageInputs */



/**
* | output |
* | --- |
* | "Error: {error}" |
*
* @param {Error_MessageInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const error_message = /** @type {((inputs: Error_MessageInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_MessageInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Erreur : ${i?.error}`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Fehler: ${i?.error}`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Errore: ${i?.error}`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Ошибка: ${i?.error}`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`错误：${i?.error}`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`エラー: ${i?.error}`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`त्रुटि: ${i?.error}`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Erro: ${i?.error}`)
	return /** @type {LocalizedString} */ (`Error: ${i?.error}`)
});